<template>
  <div>
    <div v-if="type === 0" class="details-tab">
      <el-row type="flex" align="middle" class="module-title-line">
        <i class="title-icon icon-atom" />
        <p class="title-text">各教务服务方数据</p>
        <el-tabs v-model="activeClass" type="card" class="details-tabs">
          <el-tab-pane label="全部班型" name="all" />
          <el-tab-pane label="基础班" name="base" />
          <el-tab-pane label="标准班" name="stand" />
        </el-tabs>
      </el-row>
      <div class="details-list">
        <div v-for="item of data" :key="item.companyId" class="details-item">
          <p class="item-title">{{ item.companyName }}</p>
          <div class="total-index">
            <div class="index-item">
              <p class="index-label">新增订单（笔）</p>
              <p class="index-num">{{ item[readKey.totalNum] | toLocalString }}</p>
            </div>
            <div class="index-item">
              <p class="index-label">应结算金额（元）</p>
              <p class="index-num">{{ [item[readKey.settleAmt], 2] | toLocalString }}</p>
            </div>
          </div>
          <div class="detail-table">
            <el-row type="flex" class="detail-row row-head">
              <p class="col-item col-1">招生服务方</p>
              <p class="col-item col-2">新增订单（笔）</p>
              <p class="col-item col-3">应结算金额（元）</p>
            </el-row>
            <el-row v-for="(v, i) of item.itemList" :key="item.companyId + i" type="flex" class="detail-row row-body">
              <p class="col-item col-1">{{ v.companyName }}</p>
              <p class="col-item col-2">{{ v[readKey.totalNum] | toLocalString }}</p>
              <p class="col-item col-3">{{ [v[readKey.settleAmt], 2] | toLocalString }}</p>
            </el-row>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="type === 1" class="details-table">
      <el-row type="flex" align="middle" class="module-title-line">
        <i class="title-icon icon-atom" />
        <p class="title-text">各招生服务方数据</p>
      </el-row>
      <el-table :data="data" class="table-el" max-height="460" border>
        <el-table-column prop="companyName" label="招生服务方名称" min-width="150" align="center" fixed />
        <el-table-column label="全部班型新增订单（笔）" min-width="180" align="center">
          <template v-slot="{ row }">
            {{ row.totalNum | toLocalString }}
          </template>
        </el-table-column>
        <el-table-column label="业绩（元）" min-width="120" align="center">
          <template v-slot="{ row }">
            {{ [row.totalAmt, 2] | toLocalString }}
          </template>
        </el-table-column>
        <el-table-column label="应结算金额" min-width="120" align="center">
          <template v-slot="{ row }">
            {{ [row.totalSettleAmt, 2] | toLocalString }}
          </template>
        </el-table-column>
        <el-table-column label="基础班新增订单（笔）" min-width="170" align="center">
          <template v-slot="{ row }">
            {{ row.baseNum | toLocalString }}
          </template>
        </el-table-column>
        <el-table-column label="业绩（元）" min-width="120" align="center">
          <template v-slot="{ row }">
            {{ [row.baseAmt, 2] | toLocalString }}
          </template>
        </el-table-column>
        <el-table-column label="应结算金额" min-width="120" align="center">
          <template v-slot="{ row }">
            {{ [row.baseSettleAmt, 2] | toLocalString }}
          </template>
        </el-table-column>
        <el-table-column label="标准班新增订单（笔）" min-width="170" align="center">
          <template v-slot="{ row }">
            {{ row.standardNum | toLocalString }}
          </template>
        </el-table-column>
        <el-table-column label="业绩（元）" min-width="120" align="center">
          <template v-slot="{ row }">
            {{ [row.standardAmt, 2] | toLocalString }}
          </template>
        </el-table-column>
        <el-table-column label="应结算金额" min-width="120" align="center">
          <template v-slot="{ row }">
            {{ [row.standardSettleAmt, 2] | toLocalString }}
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Detail',

  props: {
    type: {
      type: Number,
      require: true
    },
    data: {
      type: Array,
      require: true
    }
  },
  data() {
    return {
      activeClass: 'all',
    }
  },
  computed: {
    readKey () {
      switch (this.activeClass) {
        case 'all':
          return {
            totalNum: 'totalNum',
            settleAmt: 'totalSettleAmt',
          }
        case 'base':
          return {
            totalNum: 'baseNum',
            settleAmt: 'baseSettleAmt',
          }
        case 'stand':
          return {
            totalNum: 'standardNum',
            settleAmt: 'standardSettleAmt',
          }
      }
      return {}
    }
  }
}
</script>

<style lang="scss" scoped>
.details-tab {
  width: 100%;
  max-width: 1540px;
  padding-top: 40px;
  overflow: hidden;
}
.details-tabs {
  margin-left: 48px;
  padding: 8px 0;
  ::v-deep .el-tabs__content {
    display: none;
  }
  ::v-deep .el-tabs__header {
    margin-bottom: 0;
    border: none;
    .el-tabs__nav.is-top {
      border: none;
    }
    .el-tabs__item {
      width: 104px;
      height: 40px;
      border-radius: 4px;
      border: 1px solid #2C8CF0;
      line-height: 40px;
      text-align: center;
      font-weight: 600;
      font-size: 14px;
      color: #2C8CF0;
      transition: all 0.12s ease-in;
      &:hover {
        background-color: rgba(44, 140, 240, 0.1);
      }
      &.is-active {
        background-color: #2C8CF0;
        color: #FFFFFF;
      }
      & + .el-tabs__item {
        margin-left: 16px;
      }
    }
  }
}
.details-list {
  width: auto;
  margin: 0 -8px;
}
.details-item {
  display: inline-block;
  vertical-align: top;
  width: 373px;
  height: auto;
  box-sizing: border-box;
  margin: 0 8px 16px;
  padding: 80px 24px 24px;
  background-color: #FFFFFF;
  border-radius: 8px;
  position: relative;
  font-size: 0;
  .item-title {
    max-width: 200px;
    height: 32px;
    padding: 0 22px 0 24px;
    background-color: rgba(44, 140, 240, 0.2);
    border-radius: 0px 100px 100px 0px;
    line-height: 32px;
    text-align: center;
    font-weight: 600;
    font-size: 14px;
    color: #2C8CF0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    position: absolute;
    left: 0;
    top: 24px;
  }
}
.total-index {
  text-align: left;
  .index-item {
    display: inline-block;
    vertical-align: top;
    width: 50%;
    .index-label {
      line-height: 18px;
      font-size: 12px;
      color: #2F2F2F;
    }
    .index-num {
      padding-top: 8px;
      line-height: 22px;
      font-weight: bold;
      font-size: 18px;
      color: #2C8CF0;
    }
  }
}
.detail-table {
  width: 100%;
  padding-top: 24px;
  text-align: right;
  .detail-row {
    width: 100%;
    box-sizing: border-box;
    padding: 0 12px;
  }
  .row-head {
    height: 32px;
    margin-bottom: 4px;
    background-color: #F4F4F4;
    border-radius: 4px;
    line-height: 32px;
    font-size: 12px;
    color: #8B8B8B;
  }
  .row-body {
    .col-item {
      padding: 8px 0;
      line-height: 18px;
      font-size: 12px;
      color: #2F2F2F;
    }
  }
  .col-1 {
    flex: 1;
    margin-right: 12px;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .col-3 {
    width: 128px;
  }
}



.details-table {
  width: 100%;
  max-width: 1540px;
  padding-top: 40px;
  overflow: hidden;
}
.table-el {
  border-radius: 8px;
  overflow: hidden;
  ::v-deep .el-table__header {
    th {
      background-color: #E7E7E8;
    }
  }
}
</style>
